import { useTranslation } from "next-i18next";

import { CopyToClipboard } from "@/features/common/components/CopyToClipboard";

export const NFTAccount = ({ walletAccount }: { walletAccount: string }) => {
  const { t } = useTranslation("profilePublic");

  return (
    <div className="flex flex-col p-3 cursor-default">
      <span className="text-lg  text-gray-900">
        {t("profilePublic:walletAccount")}
      </span>

      <div className="flex items-center mt-2">
        <span className="flex-1 text-base  text-gray-700 truncate">
          {walletAccount}
        </span>
        <CopyToClipboard target={walletAccount} />
      </div>
    </div>
  );
};
